import { render, staticRenderFns } from "./RevenueOverviewPage.vue?vue&type=template&id=2cd2f8d6&scoped=true"
import script from "./RevenueOverviewPage.vue?vue&type=script&lang=js"
export * from "./RevenueOverviewPage.vue?vue&type=script&lang=js"
import style0 from "./RevenueOverviewPage.vue?vue&type=style&index=0&id=2cd2f8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2f8d6",
  null
  
)

export default component.exports